import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResetPasswordCheckComponent } from './reset.password.check.component';
import { ResetPasswordComponent } from './reset.password.component';
import { ResetPasswordErrorComponent } from './reset.password.error.component';
import { ResetPasswordSentComponent } from './reset.password.sent.component';
import { ResetPasswordUpdatedComponent } from './reset.password.updated.component';
import { SignupComponent } from './signup.component';
import { SignupConfirmedComponent } from './signup.confirmed.component';
import { SignupErrorComponent } from './signup.error.component';
import { SignupSucceedComponent } from './signup.succeed.component';
import { VerifyPasswordErrorComponent } from './verify.password.error.component';


const routes: Routes = [
  { path: '', redirectTo: '/signup', pathMatch: 'full' },
  { path: 'signup', component: SignupComponent },
  { path: 'signup_succeed', component: SignupSucceedComponent },
  { path: 'signup_confirmed', component: SignupConfirmedComponent },


  { path: 'reset_password', component: ResetPasswordComponent },
  { path: 'reset_password_sent', component: ResetPasswordSentComponent },
  { path: 'reset_password_updated', component: ResetPasswordUpdatedComponent },
  { path: 'error', component: ResetPasswordErrorComponent },
  { path: 'signup_error', component: SignupErrorComponent },
  { path: 'verify_error', component: VerifyPasswordErrorComponent },


  { path: 'reset_password_check/:email/:token', component: ResetPasswordCheckComponent },


];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
